(function () {
  'use strict';

  angular.module('app').component('planPage', planDetailComponent());

  function planDetailComponent() {
    return {
      controller: PlanDetailCtrl,
      controllerAs: 'vm',
      bindings: {},
      templateUrl: './app/ajs/admin/plans/plan-page.component.html',
    };
  }

  PlanDetailCtrl.$inject = ['$location', '$routeParams', 'PlanService'];

  function PlanDetailCtrl($location, $routeParams, PlanService) {
    var vm = this;

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    vm.onSavedItem = onSavedItem;
    vm.onCanceledItem = onCanceledItem;

    // Initializers
    getItem();

    function getItem() {
      if (itemId) {
        // edit
        vm.loadingItem = true;
        PlanService.getPlan(itemId).then(function (data) {
          vm.item = data;

          vm.loadingItem = false;
        });
      } else {
        vm.item = {};
      }
    }

    function onSavedItem(item) {
      $location.path(`/plans/${item.id}`);
    }

    function onCanceledItem() {
      $location.path('/plans');
    }
  }
})();
